// extracted by mini-css-extract-plugin
export default {"Login_container":"SignUp_Login_container__Anf6t","Login":"SignUp_Login__wzHMV","Login_button":"SignUp_Login_button__Y4eln","login_icon":"SignUp_login_icon__DdBsw"};